import { SurveyCityTargetFields } from './types'

export const dbTargetToReduxTargets = (field: SurveyCityTargetFields) => {
  const [_, time, param] = field.split('_')
  const parameter: 'value' | 'year' = (param as 'percent' | 'year') === 'percent' ? 'value' : 'year'
  const target: 'near' | 'long' = (time as 'near' | 'far') === 'near' ? 'near' : 'long'
  return { parameter, target }
}
